import React from 'react';
import ImageWithFallback from "./ImageWithFallback";

class CenteredImageContainer extends React.Component {
    render() {
        return (
            <div className="container-2-1">
                <ImageWithFallback
                    className="container-2-1-img cover-fit"
                    alt={this.props.alt}
                    src={this.props.src}
                />
            </div>
        );
    }
}

export default CenteredImageContainer;